import { Navigate } from "react-router-dom";
import { useCustomerAuth } from "@/contexts/CustomerAuthContext";

export default function CustomerProtectedRoute({ children }) {
  const { user } = useCustomerAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-bg">
        <div className="h-10 w-10 rounded-full border-4 border-brand-green/30 border-t-brand-green animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
